<app-error [code]="code" [css_class]="css_class" [description]="description" [icon]="icon"></app-error>
